<script setup lang="ts">
// Shared loading placeholder. Size it with utility classes (h-*, w-*).
// motion-safe: shimmer only when the user has not set prefers-reduced-motion.
</script>

<template>
  <div aria-hidden="true" class="bg-cc-hover rounded motion-safe:animate-pulse"></div>
</template>
